// Shared option lists for the patient feedback review UI. Values mirror the
// public form (forms/PatientFeedback.jsx) and the KPI/CQC consumers.
export const FEEDBACK_STATUSES = ['New', 'Reviewing', 'Completed']

export const statusColor = (status) =>
  status === 'Reviewing'
    ? 'warning'
    : status === 'Completed'
      ? 'success'
      : 'error' // New / unset

export const FEEDBACK_QUESTIONS = [
  { key: 'dignityRespect', label: 'Treated with dignity and respect' },
  { key: 'involved', label: 'Involved in decisions about their care' },
  { key: 'kindHelpful', label: 'Staff were kind and helpful' },
  { key: 'confidenceTrust', label: 'Confidence and trust in the staff' },
  { key: 'ambulanceCare', label: 'Treated or transported in an ambulance' },
]
